import { SiteCoreDictionary } from './types';

const fallbackDictionary: SiteCoreDictionary = {
    blockStep1Legend: 'Hvorfor vil du sperre kortet ditt permanent?',
    blockStep2Legend: 'Vil du bestille nytt kort?',
    blockTitle: 'Sperr kort',
    formBack: 'Tilbake',
    formCancel: 'Avbryt',
    formNext: 'Neste',
    blockReason_LOST: 'Jeg har mistet kortet',
    blockReason_STOLEN: 'Kortet er stjålet eller misbrukt av andre',
    blockReason_DAMAGED: 'Forny skadet/ødelagt kort',
    blockReason_NOT_IN_USE: 'Kortet er ikke i bruk',

    unauthorisedUseCardInfo:
        'Ettersom kortet er misbrukt av andre, må du ta kontakt med vårt kundesenter for å få bestilt nytt kort. Du vil også få nyttig veiledning om hva du bør gjøre videre.',
};

export default fallbackDictionary;
